module.exports = __webpack_public_path__ + "img/nat-6.1ef6d764.jpg";